/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
var klaviyo = klaviyo || [];
  klaviyo.init({
    account: "YiLPT6",
    platform: "shopify"
  });
  klaviyo.enable("backinstock",{ 
  trigger: {
    product_page_text: "Notify Me When Available",
    product_page_class: "btn",
    product_page_text_align: "center",
    product_page_margin: "0px",
    replace_anchor: false
  },
  modal: {
    headline: "{product_name}",
    body_content: "¡Anótate a la lista y te llegará un correo en cuanto volvamos a tener este producto disponible!",
    email_field_label: "Correo electrónico",
    button_label: "Anotarme",
    subscription_success_label: "¡Listo! Te avisaremos cuando esté disponible",
    footer_content: '',
    additional_styles: "@import url(//manika.mx/cdn/shop/t/48/assets/css-klaviyo-bis.css?v=40131384114638686651744296233);@import url('https://fonts.googleapis.com/css2?family=Cardo:ital,wght@0,400&family=Montserrat:ital,wght@0,400&display=swap');:root{--dropdown-arrow: url(//manika.mx/cdn/shop/t/48/assets/icon-dropdown-arrow.svg?v=13234763857970875331744296233)}",
    drop_background_color: "#000",
    background_color: "#fff",
    text_color: "#222",
    button_text_color: "#fff",
    button_background_color: "#439fdb",
    close_button_color: "#ccc",
    error_background_color: "#fcd6d7",
    error_text_color: "#C72E2F",
    success_background_color: "#d3efcd",
    success_text_color: "#1B9500"
  }
});
